/**
 * Created by lijie on 2017/1/5.
 */
import login from '@vdian/login';

Vue.http.options.credentials = true;
const Common = {
    htmlEscape: function (string) {
        var escapeMap = {
            // '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#x27;'
        };
        var escaper = function (match) {
            return escapeMap[match];
        };
        var source = '(?:' + Object.keys(escapeMap).join('|') + ')';
        var testRegexp = RegExp(source);
        var replaceRegexp = RegExp(source, 'g');
        string = string == null ? '' : '' + string;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    },
    getCookie: function (name) {
        var cookie_start = document.cookie.indexOf(name + "="), cookie_end = document.cookie.indexOf(";", cookie_start);
        return cookie_start == -1 ? "" : unescape(document.cookie.substring(cookie_start + name.length + 1, (cookie_end > cookie_start ? cookie_end : document.cookie.length)));
    },
    vdianLogin(){
        let url = login.login({
            oauth: 0,//不显示第三方登录
            device: 1,//移动端登录
            force: 1//不知道干嘛
        });
        location.href = url;
    },
    isSellerLogin() {
       return login.isSellerLogin();
    },
    isBuyerLogin() {
        return login.isLogin();
    },
    wechatForceLogin(){
        let url = login.wechatForceLogin();
        location.href = url;
    },
    shouldLogin(){
        if (!this.isBuyerLogin()) {
            if (/MicroMessenger/i.test(navigator.userAgent) && !(/wxwork/i.test(navigator.userAgent))) {
                this.wechatForceLogin();
            } else {
                this.vdianLogin();
            }

        }
    },
    get(url, data){
        if(/\/mock\//.test(url)) {
            url += '/index.json';
        }
        let paramData = {};
        if (data) {
            paramData = {param: JSON.stringify(data)}
        }
        return new Promise((resolve, reject) => {
            Vue.http.get(url, {params: paramData}).then((response) => {
                resolve({data: response.body, header: response.headers})
            }, reject)
        });
    },
    ajax(url, data) {
        if(/\/mock\//.test(url)) {
            return this.get(url,data);
        }else {
            let paramData = {};
            if (data) {
                paramData = {param: JSON.stringify(data)}
            }
            return new Promise((resolve, reject) => {
                Vue.http.post(url, paramData, {emulateJSON: true}).then((response) => {
                    resolve({data: response.body, header: response.headers})
                }, reject)
            })
        }
    },
    //jsonp跨域处理
    jsonp(url, data) {
        if(/\/mock\//.test(url)) {
            return this.get(url,data);
        }else {
            let paramData = {};
            if (data) {
                paramData = {params: {param: JSON.stringify(data)}}
            }
            return new Promise((resolve, reject) => {
                Vue.http.jsonp(url, paramData, {emulateJSON: true}).then((response) => {
                    resolve({data: response.body, header: response.headers})
                }, reject)
            })
        }
    },
    jsonpVap(config) {
        this.jsonp(config.url,config.dataIn).then(data => {
                let resData = data && data.data || {};
                if (resData.status && resData.status.status_code === 0) {
                    config.ok(resData);
                } else {
                    //出错
                    config.error();
                }
            },
            () => {
                //断网
                config.error();
            }
        );
    },
    post(url, data){
        if(/\/mock\//.test(url)) {
            return this.get(url,data);
        }else {
            let paramData = {};
            if (data) {
                paramData = {param: JSON.stringify(data)}
            }
            return new Promise((resolve, reject) => {
                Vue.http.post(url, paramData, {emulateJSON: true}).then((response) => {
                    resolve({data: response.body, header: response.headers})
                }, reject)
            })
        }
    },
    thorPost(url, data){
        if(/\/mock\//.test(url)) {
            return this.get(url,data);
        }else {
            let paramData = {};
            if (data) {
                paramData = {param: JSON.stringify(data)}
            }
            return new Promise((resolve, reject) => {
                Vue.http.post(url, paramData, {emulateJSON: true}).then((response) => {
                    resolve({data: response.body, header: response.headers})
                }, reject)
            })
        }
    },
    //config.url  config.dataIn config.ok  config.error
    vap(config){
        this.post(config.url,config.dataIn).then(data => {
                let resData = data.data;
                if (resData.status && resData.status.code === 0 && resData.result) {
                    if(resData.result.success === true) {
                        //正常逻辑
                        config.ok(resData.result);
                    }else {
                        new Kub.Toast({
                            top: 300,
                            message: resData.result.errorMsg,
                            delay: 1500
                        });
                    }

                } else if (resData.status && resData.status.code === 2) {
                    //登录
                    Common.vdianLogin();
                } else {
                    //出错
                    config.error();
                }
            },
            () => {
                //断网
                config.error();
            }
        );
    },
    //url添加时间戳
    updateUrl(url,key) {
        var key= (key || 't') +'=';  //默认是"t"
        var reg=new RegExp(key+'\\d+');  //正则：t=1472286066028
        var timestamp=+new Date();
        if(url.indexOf(key)>-1){ //有时间戳，直接更新
            return url.replace(reg,key+timestamp);
        }else{  //没有时间戳，加上时间戳
            if(url.indexOf('\?')>-1){
                var urlArr=url.split('\?');
                if(urlArr[1]){
                    return urlArr[0]+'?'+key+timestamp+'&'+urlArr[1];
                }else{
                    return urlArr[0]+'?'+key+timestamp;
                }
            }else{
                if(url.indexOf('#')>-1){
                    return url.split('#')[0]+'?'+key+timestamp+location.hash;
                }else{
                    return url+'?'+key+timestamp;
                }
            }
        }
    },

    format2Code(url){
        var pattern = /[&?]code=(.{10})(?:&|#|$)/;
        var realCode = url.match(pattern) && url.match(pattern)[1];
        var query = window.Kub.core.getQuerystring(url);
        if(realCode) {
            query.code = realCode;
        }
        return window.Kub.core.setQuerystring(url,query);
    }
};
export default Common;



/** WEBPACK FOOTER **
 ** ./common/js/common.js
 **/